<div class="view-content">
  @if (success) {
    <div class="view-section success">
      <p>{{ 'jobboard.views.job-no-interest.success' | transloco }}</p>
    </div>
  }
</div>

